import formValidator, {
	required,
	isCorrectEmailLen,
	maxLen,
	isEmail,
} from "@insightfulscience/shared-utils/validation";

export const initialState = {
	email: "",
	firstName: "",
	lastName: "",
	team: "",
	licenses: "",
	hasSponsored: "",
};

const schema = {
	email: [
		[required, "errors.EMAIL_REQUIRED"],
		[isCorrectEmailLen(64), "errors.EMAIL_INVALID_LENGTH"],
		[email => isEmail(email), "errors.EMAIL_INVALID"],
		[maxLen(100), "errors.WRONG_EMAIL"],
	],
	firstName: [required, "errors.FIRST_NAME_REQUIRED"],
	lastName: [required, "errors.LAST_NAME_REQUIRED"],
	team: [required, "errors.TEAM_NAME_REQUIRED"],
	licenses: [
		[required, "errors.LICENSES_REQUIRED"],
		[
			numberOfLicenses => required((numberOfLicenses < 1 || numberOfLicenses > 999999999) && null),
			"errors.LICENSES_WRONG",
		],
	],
	hasSponsored: [required, "errors.HAS_SPONSORED_REQUIRED"],
};

export const validateForm = formValidator(schema);
